export function isPdfUrl(url) {
  return /\.pdf(?:$|[?#])/i.test(String(url || '').trim());
}

export function certificateFileName(url) {
  const raw = String(url || '').trim().split('?')[0];
  const name = raw.split('/').pop();
  return name || 'certificate';
}
